import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Dialog, DialogTitle, Grid, Toolbar, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        marginLeft: "auto",
        marginRight: "auto",
        width: "80%",
    },
    header: {
        background: '#68389F',
        color: 'white'
    },
    formControl: {
        marginTop: 15,
        minWidth: 120,
    },
    botonera: {
        marginTop: 50,
        marginLeft: 55,
        marginBottom: 20,
        paddingBottom: 13
    },
}));

export const ModalOpciones = (props) => {
    const classes = useStyles();
    const { open, onCloseModal, title, opciones, onChoseOption } = props;
    
    const closeModal = () => {
        onCloseModal();
    }
    
    return (
        <Dialog
            maxWidth="md"
            fullWidth={true}
            open={open}
            onClose={closeModal}
        >
            <DialogTitle className={classes.header}>
                <Toolbar >
                    <Typography variant="h6" >
                        {title}
                    </Typography>
                </Toolbar>
            </DialogTitle>
              <div className={classes.root}>
                  <Grid className={classes.botonera} container >
                      <Grid item xs={10}>
                            <Grid
                                container
                                direction="row"
                                justify="space-between"
                                alignItems="center"
                            >
                                {opciones.map((item, i) => 
                                    <Button
                                        key={i}
                                        variant="contained"
                                        color={i % 2 ? 'secondary' : 'primary'}
                                        onClick={() => onChoseOption(i)}
                                    >
                                        {item}
                                    </Button>
                                )}
                          </Grid>
                      </Grid>
                  </Grid>
              </div>
        </Dialog>
    );

};
